function isHtml(string){
    return /<\/?[a-z][\s\S]*>/i.test(string)
} 

export default isHtml;